export const voucherCodeFormName = 'voucherCode';
export const voucherName = 'Voucher';
export const errorCodeConstant = [1106];
export const paymentFormName = 'paymentTermsAndConditions';

export const currency3DS_url = {
  SBX: 'https://config-currency.s3.eu-central-1.amazonaws.com/ConfigCurrencySBX1.JSON',
  PRD: 'https://config-currency.s3.eu-central-1.amazonaws.com/ConfigCurrency.JSON',
  PRF: 'https://config-currency.s3.eu-central-1.amazonaws.com/ConfigCurrencyPRF2.JSON',
};

export const environment = {
  SBX: 'SBX',
  PRD: 'PRD',
  PRF: 'PRF2',
};

export const newsFieldLocation = {
  Checkout: 'Checkout',
  MyAccount: 'MyAccount',
};

export const threeDSSettings = {
  cyberSource: {
    songbirdUrl: {
      sandbox: 'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js',
      staging: 'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js',
      production: 'https://songbird.cardinalcommerce.com/edge/v1/songbird.js',
    },
    settings: {
      config: {
        timeout: 8000,
        maxRequestRetries: 2,
        logging: {
          level: 'on',
        },
      },
    },
  },
};

export const sbxAPIurl = 'https://services.sbx1.cdops.net';

export const windowCardinalConstants = {
  initialization: 'init',
  binProcess: 'bin.process',
  paymentSetUpComplete: 'payments.setupComplete',
  paymentsValidated: 'payments.validated',
};

export const windowUrlList = ['localhost', 'demo.cdops.net', 'f1.ascendon.tv'];
export const apigeeWindowUrl = 'https://qa-api.f1.lbi.co.uk/v1';
export const apiKeyWindowUrl = '5v8zEiQyYBcGs9NGOemmKVRdr0xGVExl';

export const submitOrderUpdateCountryUrl =
  '/account/Subscriber/SubmitOrderUpdateCountry';

export const subscriptionOptionsUrl =
  '/proposition-page-metadata/subscription-options';

export const submitModifyOrderUpdateCountryUrl =
  '/account/Subscriber/SubmitModifyOrderUpdateCountry';

export const stripePaymentCountryList = ['USA', 'GBR'];
